__turbopack_context__.v({
  "button": "sK6PjW_button",
  "green": "sK6PjW_green",
  "highlightCard": "sK6PjW_highlightCard",
  "subtitle": "sK6PjW_subtitle",
  "title": "sK6PjW_title",
});
